import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CollageSection } from '../CollageSection';
import { collageData } from '../../config/collageData';
import { useCollageLinks } from '../../hooks/useCollageLinks';
import butterfly_pattern from '../../assets/butterfly_pattern.png';
import './Homepage.css';

export const Homepage: React.FC = () => {
    const { linkMap, loading } = useCollageLinks();

    // Overlay DB link overrides on top of the static collageData config.
    // Falls back to the hardcoded link when no DB override exists.
    const collages = useMemo(() => {
        if (loading) return collageData;
        return collageData.map(collage => ({
            ...collage,
            clickableItems: collage.clickableItems.map(item => {
                const override = linkMap[`${collage.id}::${item.alt}`];
                return override ? { ...item, link: override } : item;
            }),
        }));
    }, [linkMap, loading]);

    return (
        <div className="homepage">
            <div className="hero-section hero-background" style={{ backgroundImage: `url(${butterfly_pattern})` }}>
                <h1 className="hero-content hero-title inverted-text">FLIEGEL.APP</h1>
                <Link to="/blog" className="blog-gif-link">
                    <img src="/moving_butterfly.gif" alt="Go to blog" className="blog-gif" />
                </Link>
            </div>
            <CollageSection collages={collages} className="seamless" />
        </div>
    );
};
